import { optionSchema } from "@/common/schemas/option.schema";
import { unFormatCurrency } from "@/common/utils/unFormatters";
import { z } from "zod";

export const addPaymentSchema = z.object({
  type: optionSchema,
  paid_total: z.string().refine(unFormatCurrency, { message: 'Campo obrigatório' }),
  pdf: z.custom().optional().nullable(),
});

export type AddPaymentValidationSchema = z.infer<typeof addPaymentSchema>;
